import { t } from "i18next";
import * as yup from "yup";

export const addSonValidationSchema = () =>
  yup.object().shape({
    nameOfSon: yup
      .string()
      .min(3, " ")
      .max(30, " ")
      .required(t("addSonForm.valiation.required")!),
    birthDate: yup.string().required(t("form.error.newpassword.required")!),
    gender: yup
      .string()
      .oneOf(["Male", "Female"], "Invalid gender")
      .required(t("addSonForm.valiation.gender.required")!),
    eduLevel: yup
      .string()
      .required(t("addSonForm.valiation.educationLevel.required")!),
    eduSystem: yup
      .string()
      .required(t("addSonForm.valiation.educationSystem.required")!),
    idNumber: yup
      .string()
      .required(t("addSonForm.valiation.required")!)
      .min(1, " ")
      .max(10, " "),
  });
